module.exports = __webpack_public_path__ + "img/technical-catechize.2d86d88b.jpg";